export default {
  // 新增品控类型报告
  insertPaTypeQcReport: '/ygsjzs/paTypeQcReport/insertPaTypeQcReport',
  // 修改品控类型报告（必传reportId）
  updatePaTypeQcReport: '/ygsjzs/paTypeQcReport/updatePaTypeQcReport',
  // 物理删除品控类型报告
  deleteDataPaTypeQcReport: '/ygsjzs/paTypeQcReport/deleteDataPaTypeQcReport',
  // 查询品控类型报告详情（反查返回 specName、manufacturerName）
  selectPaTypeQcReportByReportId: '/ygsjzs/paTypeQcReport/selectPaTypeQcReportByReportId',
  // 分页查询品控类型报告列表（每条反查返回 specName、manufacturerName）
  selectPaTypeQcReportByPage: '/ygsjzs/paTypeQcReport/selectPaTypeQcReportByPage',
  // 导出品控类型报告
  exportPaTypeQcReport: '/ygsjzs/paTypeQcReport/exportPaTypeQcReport'
}
